import React, { useContext } from "react";
import { CButton, CImage } from "@app/components/Common";
import { useFavourite } from "@app/hooks";
import { Text, View } from "@/styles/reactnative";
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import { ThemeContext } from "@/theme/ThemeProvider";
import { COLORS } from "@app/constants";

const ListCoin = ({ item }) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { data: favourites, toggleFavourite, isLoading } = useFavourite();
  
  const isBookmarked = favourites?.find?.((f: any) => f?.ep_id === item?.ep_id);
  
  const icon = isBookmarked ? (
    <IconStarFilled size={20} style={{ color: COLORS.primary }} />
  ) : (
    <IconStar color={textw} size={20} />
  );

  const handleClick = async () => {
    if (isLoading) return; // 로딩 중에는 클릭 방지
    await toggleFavourite(item);
  };

  return (
    <View
      style={{
        width: "35%",
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "row",
      }}
    >
      <CButton
        icon={icon}
        style={{ 
          marginRight: 5,
          opacity: isLoading ? 0.6 : 1
        }}
        onClick={handleClick}
      />
      <View style={{ flexDirection: "row" }}>
        <CImage
          src={item?.image}
          alt="logo"
          width={18}
          height={18}
          resizeMode={"cover"}
          style={{ borderRadius: 50 }}
        />
        <Text
          style={{
            marginLeft: 5,
            fontWeight: "bold",
            fontSize: 12,
          }}
        >
          {item?.pairs}
        </Text>
      </View>
    </View>
  );
};

export default ListCoin;
